import m from './m.js'
import './i18n.js' // sets m.t
import { auth } from './api.js'
import { initTooltips } from './tooltip.js'
import { boardView } from './views/board.js'
import { homeView, layoutView } from './views/layout.js'

// RouteResolvers with render() keep the board's tree alive between
// "/:owner/:repo" and "/:owner/:repo/:number", so opening a card does not reload the board.
function page(view) {
  return { render: ({ attrs }) => layoutView(attrs, view(attrs)) }
}

m.route.prefix = ''
initTooltips()
auth.load().then(() =>
  m.route(document.body, '/', {
    '/': page(homeView),
    '/:owner/:repo': page(boardView),
    '/:owner/:repo/:number': page(boardView),
    // a pull request's "Files changed" tab, see detailView
    '/:owner/:repo/:number/changes': page(boardView),
  })
)
